module.exports = __webpack_public_path__ + "img/fastplus-donator.56c16b0d.png";